import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

import BreakingNews from "../../components/BreakingNews";
import RightSidebar from "../../components/RightSidebar";
import NewsCard from "../../components/NewsCard";
import Profilecard from "../../components/Profilecard";

const NewsDetail = () => {
  const { id } = useParams();

  const [news, setNews] = useState(null);
  const [moreNews, setMoreNews] = useState([]);

  useEffect(() => {
    // 🔥 Scroll to top
    window.scrollTo({ top: 0, behavior: "auto" });

    // 🔥 VERY IMPORTANT: Stop any running speech before loading new page
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }

    // ================= FETCH MAIN NEWS =================
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}product/one/${id}`)
      .then((res) => {
        setNews(res.data);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
      });

    // ================= FETCH MORE NEWS =================
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}product`)
      .then((res) => {
        setMoreNews(res.data.slice(0, 6));
      })
      .catch((err) => {
        console.error("Error fetching more news:", err);
      });

    // 🔥 Cleanup on unmount
    return () => {
      if (window.speechSynthesis) {
        window.speechSynthesis.cancel();
      }
    };
  }, [id]);

  if (!news) {
    return <div className="p-10 text-center">Loading...</div>;
  }

  return (
    <>
      {/* ================= SEO ================= */}
      <Helmet>
        <title>{news.news_title} | Bundeli Chugli</title>

        <meta
          name="description"
          content={news.description?.slice(0, 160)}
        />

        <meta property="og:type" content="article" />
        <meta property="og:title" content={news.news_title} />
        <meta
          property="og:description"
          content={news.description?.slice(0, 160)}
        />

        <meta
          property="og:image"
          content={`${process.env.REACT_APP_BACKEND_URL.replace(
            "/api/v1/",
            ""
          )}/uploads/news/${news.thumbnail}`}
        />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 pt-2 pb-6">
        <BreakingNews />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-4">
          {/* ================= MAIN ARTICLE ================= */}
          <div className="lg:col-span-9">
            <Profilecard data={news} />
          </div>

          {/* ================= SIDEBAR ================= */}
          <RightSidebar />
        </div>

        {/* ================= MORE NEWS ================= */}
        <section className="mt-12">
          <h2 className="text-xl font-bold mb-4 border-b pb-2 text-red-600">
            और खबरें
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {moreNews.map((item) => (
              <NewsCard
                key={item.id}
                title={item.news_title}
                image={`${process.env.REACT_APP_BACKEND_URL.replace(
                  "/api/v1/",
                  ""
                )}/uploads/news/${item.thumbnail}`}
                category={item.category}
                date={item.createdAt}
                fullNews={item.description}
                author="Bundeli Chugli"
                readTime="2 Min Read"
                link={`/news/${item.id}`}
                videoUrl={item.youtube_url}
              />
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default NewsDetail;
